export default __webpack_public_path__ + "static/media/formatOnePlaySelected.1cbed0ad.svg";